/**
 * Maps file extensions to icon names
 * Used for displaying appropriate icons in file explorers and lists
 */
export const getFileIconName = (filePath) => {
  if (!filePath) return 'file';
  
  const ext = filePath.split('.').pop().toLowerCase();
  const fileName = filePath.split('/').pop().toLowerCase();
  
  // Special filenames
  if (fileName === 'dockerfile') return 'docker';
  if (fileName === 'docker-compose.yml') return 'docker';
  if (fileName === '.gitignore' || fileName === '.gitattributes') return 'git';
  
  // Extension mapping
  const iconMap = {
    // JavaScript/TypeScript
    js: 'javascript',
    jsx: 'react',
    ts: 'typescript',
    tsx: 'react',
    
    // Markup/Data
    json: 'json',
    html: 'html',
    htm: 'html',
    xml: 'code-file',
    
    // Styles
    css: 'css',
    scss: 'css',
    sass: 'css',
    less: 'css',
    
    // Documentation
    md: 'document',
    mdx: 'document',
    txt: 'document',
    doc: 'document',
    docx: 'document',
    pdf: 'document',
    
    // Programming Languages
    py: 'python',
    pyc: 'python',
    java: 'code-file',
    go: 'code-file',
    rs: 'code-file',
    c: 'code-file',
    cpp: 'code-file',
    h: 'code-file',
    hpp: 'code-file',
    
    // Config/Settings
    yml: 'settings',
    yaml: 'settings',
    toml: 'settings',
    ini: 'settings',
    conf: 'settings',
    config: 'settings',
    env: 'settings',
    
    // Database
    sql: 'database',
    db: 'database',
    sqlite: 'database',
    
    // Shell/Scripts
    sh: 'terminal',
    bash: 'terminal',
    zsh: 'terminal',
    fish: 'terminal',
    ps1: 'terminal',
    
    // Docker
    dockerfile: 'docker',
    
    // Images
    svg: 'image',
    png: 'image',
    jpg: 'image',
    jpeg: 'image',
    gif: 'image',
    webp: 'image',
    ico: 'image',
    
    // Video
    mp4: 'video',
    mov: 'video',
    avi: 'video',
    webm: 'video',
  };
  
  return iconMap[ext] || 'file';
};

/**
 * Get icon color based on file type (optional, for additional styling)
 */
export const getFileIconColor = (filePath) => {
  if (!filePath) return null;
  
  const iconName = getFileIconName(filePath);
  
  const colorMap = {
    javascript: '#f7df1e',
    react: '#61dafb',
    typescript: '#3178c6',
    html: '#e34c26',
    css: '#1572b6',
    python: '#3776ab',
    json: '#fbbf24',
    docker: '#2496ed',
    git: '#f05032',
    database: '#10b981',
  };
  
  return colorMap[iconName] || null;
};
